import { clearTenantConfig } from '../../tenant-config/tenantConfigSlice';
import { clearInitConfig, updateInitConfig } from '../../init-config/initConfigSlice';
import { InitConfigState } from '../../init-config/initConfigTypes';
import { clearExportV4ApiKey } from '../../components/preferences/general/generalSettingsSlice';
import { clearCurrentUser, fetchCurrentUserSuccess } from '../../../current-user/currentUserSlice';
import ErrorNotifier from '../../services/error-notifier';
import { parseCurrentUser } from '../../../current-user/currentUserUtils';
import { CurrentUserResponse } from '../../../current-user/currentUserTypes';
import { AnalyticsProvider } from '../../services/analytics-provider';
import { SpotsResponse } from '../../../spot-selector/spotSelectorTypes';
import { getNetwork } from '../../services/app-state';
import { addSpots, clearSpotSelector } from '../../../spot-selector/spotSelectorSlice';
import { parseSpots } from '../../../spot-selector/spotSelectorUtils';
import { clearSuperAdmin } from '../../../auth/authSlice';

import { dispatch } from 'state/store';
import { updateAppSpotId } from 'state/app-state/reducer';

export function syncCurrentUserToRedux(user: CurrentUserResponse) {
  const currentUserData = parseCurrentUser(user);
  dispatch(fetchCurrentUserSuccess(currentUserData));

  AnalyticsProvider.initializePeople(currentUserData);
  ErrorNotifier.setUser(currentUserData);
}

export function syncSpotsToRedux(response: SpotsResponse) {
  const network = getNetwork().id;

  const spots = parseSpots(response, network);

  dispatch(addSpots(spots));

  return spots;
}

export function clearCurrentUserFromRedux() {
  dispatch(clearCurrentUser());

  ErrorNotifier.setUser(null);
}

export function syncSpotIdToRedux(spotId: string) {
  dispatch(updateAppSpotId(spotId));
}

export function clearTenantConfigFromRedux() {
  dispatch(clearTenantConfig());
}

export function clearInitConfigFromRedux() {
  dispatch(clearInitConfig());
}

export function syncInitConfigToRedux(initConfig: Partial<InitConfigState>) {
  dispatch(updateInitConfig(initConfig));
}

export function clearSpotSelectorFromRedux() {
  dispatch(clearSpotSelector());
}

export function clearSuperAdminFromRedux() {
  dispatch(clearSuperAdmin());
}

export function clearSpotDataFromRedux() {
  clearInitConfigFromRedux();
  clearTenantConfigFromRedux();
  clearCurrentUserFromRedux();
}

export function clearExportV4ApiKeyFromRedux() {
  dispatch(clearExportV4ApiKey());
}
